var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.809082,44c0.277832,0,0.5566406-0.0654297,0.809082-0.1904297l9.2485352-4.625 c0.4804688-0.2402344,0.9174805-0.5556641,1.2993164-0.9365234L44.4638672,8.9501953 C45.4545898,7.9599609,46,6.6435547,46,5.2421875C46,2.3515625,43.6479492,0,40.7573242,0 c-1.3994141,0-2.7158203,0.5449219-3.7070312,1.5351562L7.7519531,30.8339844 c-0.3803711,0.3798828-0.6953125,0.8173828-0.9370117,1.2998047L2.190918,41.3818359 C2.065918,41.6318359,2,41.9121094,2,42.1914062C2,43.1884766,2.8115234,44,3.809082,44z M8.6040039,33.0283203 c0.1450195-0.2900391,0.3339844-0.5527344,0.5615234-0.7792969L38.4638672,2.9501953 C39.0771484,2.3369141,39.8916016,2,40.7573242,2C42.5454102,2,44,3.4541016,44,5.2421875 c0,0.8671875-0.3369141,1.6806641-0.949707,2.2929688L13.7524414,36.8330078 c-0.2290039,0.2294922-0.4916992,0.4179688-0.7802734,0.5625l-8.7504883,4.3974609L8.6040039,33.0283203z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 46,
    width: 44,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMedium);
export default __webpack_public_path__ + "static/media/edit--medium.12926985dab6b7c0cb028abbbd76ad2a.svg";
export { ForwardRef as ReactComponent };